export default "__VITE_ASSET__DK4JcpLf__"